import { h, Component } from 'preact';
import {Button, Form, I18n, Container, Row, Col} from 'components/elements' 
import {PatientSelectCard} from 'components/groups'
import {times} from 'lib/helpers'
import {connect} from 'react-redux'
import style from './style.less'
import dayjs from 'dayjs'
import { PatientActions } from 'actions';

@Form
@connect((state)=>({
	...state
}))
export default class PatientSelectHorizontal extends Component {
	constructor(){
        super()
        this.state = {
            newPatient: '',
            patientPage: 0
        }
        this.patientsToCreate = this.patientsToCreate.bind(this)
        this.handleNewPatient = this.handleNewPatient.bind(this)
        this.handlePrevPatients = this.handlePrevPatients.bind(this)
        this.handleNextPatients = this.handleNextPatients.bind(this)
        this.handlePatientSelect = this.handlePatientSelect.bind(this)
        this.handleNewPatientSubmit = this.handleNewPatientSubmit.bind(this)
        this.handleNewPatientCancel = this.handleNewPatientCancel.bind(this)
    }
    
    get newPatientCount(){
        let newPatientCount = this.patients.filter((patient)=>/newPatient/.test(patient.id)).length
        return newPatientCount
    }

    get patients(){
        return Object.values(this.props.patients || {}).sort((a,b)=>{
            if(/newPatient/.test(a.id)) return -1
            if(/newPatient/.test(b.id)) return 1
            if(a.name > b.name) return 1
            if(a.name < b.name) return -1
        })
    }

    get patientsReversed() {
        const value = [...this.patients]
        value.reverse()
        return value
    }
    
    get appointmentTypes(){
        return Object.values(this.props.appointmentTypes || {}).filter((appType)=>{
            if(appType.userType && ((!(this.props.session || {}).accessToken && appType.userType == 'returning') || ((this.props.session || {}).accessToken && appType.userType == 'new'))){
                return false
            }
            let maxPatients = 1
            if(appType.durations){
                maxPatients = appType.durations.split(',').length 
            }
            if(!this.props.filters.patientCount || this.props.filters.patientCount <= maxPatients){
                return true
            }
            return false
        })
    }

    get appointmentType(){
        return this.props.appointmentTypes[this.props.filters.appointmentTypeID] || {}
    }

    get hasRestrictions(){
        return (this.appointmentType.rules || []).length > 0
    }

    get weightUnit(){
        switch(this.organization.country){
            case "US":
                return I18n.t('lbs')
            case "CA":
                return I18n.t('kg')
            default:
                return I18n.t('lbs')
        }
    }

    get organization(){
        return this.props.organization || {}
    }

    handlePrevPatients(){
        if(this.state.patientPage > 0){
            this.setState({
                patientPage: this.state.patientPage - 3
            })
        }
    }

    handleNextPatients(){
        if(this.state.patientPage < (this.patients.length - 2)){
            this.setState({
                patientPage: this.state.patientPage + 3
            })
        }
    }

    handleNewPatient(e){
        e.preventDefault()
        this.setState({
            newPatient: {}
        })
    }

    handleNewPatientCancel(e){
        e.preventDefault()
        this.setState({
            newPatient: ''
        })
    }

    handleNewPatientSubmit(values){
        this.setState({
            newPatient: ''
        })
        let patient = {
            ...values,
            id: `newPatient-${values.firstName.replace(/ /g, '-')}-${values.lastName.replace(/ /g, '-')}`,
        }
        
        PatientActions.append(patient)

        this.handlePatientSelect(patient)
    }

    handlePatientSelect(patient){
        this.setState({})
        this.props.onPatientSelect && this.props.onPatientSelect(patient)
    }

    patientsToCreate(){
        let numNewPatients = this.patients.length
        let count = this.props.filters.patientCount - numNewPatients
        if(count <= 0 && this.state.newPatient){
            count = 1
        }
        return count
    }

	render(){
        const {Form, InputDark, SelectDark, FormData} = this.props
		return (
            <div>
                <Row>
                    <Col span={{sm: 2, md:2}} class={[style.leftArrow,this.state.patientPage == 0 && style.disabled].join(' ')} onClick={this.handlePrevPatients}>
                        {this.patients.length > 2 &&
                            <div>
                                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                            </div> 
                        }
                    </Col>
                    <Col span={{sm: 20, md:20}}>
                        <Row>
                            {times(3).map((i)=>{
                                const patient = this.patients[i - 1 + this.state.patientPage]
                                const selected = patient && Object.keys(this.props.selectedPatients).indexOf(patient.id) != -1
                                return (
                                    <Col span={{sm: 24, md:8}}>
                                        {i == 0 && this.state.patientPage == 0 ? (
                                            this.state.newPatient ? (
                                                <div>
                                                    {times(this.patientsToCreate()).map((i)=>{
                                                        return (
                                                            <Container key={`new-patient-container-${this.newPatientCount + i}`} >
                                                                <Form onSubmit={this.handleNewPatientSubmit}>
                                                                    <InputDark 
                                                                        required={true} 
                                                                        name='firstName' 
                                                                        type='text' 
                                                                        question='First Name' 
                                                                        class={style.newPatientField} 
                                                                        initialValue={''}
                                                                    />
                                                                    <InputDark 
                                                                        required={true} 
                                                                        name='lastName' 
                                                                        type='text' 
                                                                        question='Last Name' 
                                                                        class={style.newPatientField} 
                                                                        initialValue={''}
                                                                    />
                                                                    <div class={style.newPatientButtonContainer}>
                                                                        {this.patientsToCreate() == 0 &&
                                                                            <Button onClick={this.handleNewPatientCancel}>Cancel</Button>
                                                                        }
                                                                        <Button class={style.newPatientButton}>Submit</Button>
                                                                    </div>
                                                                </Form>
                                                            </Container>
                                                        )
                                                    })}
                                                </div>
                                            ) : (
                                                <Container key="new-patient-prompt" class={style.newPatient} onClick={this.handleNewPatient}>
                                                    <div style={{padding: '30px 20px 33px 20px'}}>   
                                                    + <I18n>addNewPatient</I18n>
                                                    </div>
                                                </Container>
                                            )
                                        ) : patient && (
                                            <PatientSelectCard 
                                                {...patient}
                                                selected={!!selected}
                                                genericPatients={this.props.config.genericPatients}
                                                onSelect={this.handlePatientSelect.bind(null, patient)} 
                                            />
                                        )}
                                    </Col>
                                )
                            })}
                        </Row>
                    </Col>

                    <Col span={{sm: 1, md: 1}} class={[style.rightArrow,this.state.patientPage >= (this.patients.length - 2) && style.disabled].join(' ')}  onClick={this.handleNextPatients}>
                        {this.patients.length > 2 &&
                            <div><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
                        }
                    </Col>
                </Row>
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/partials/PatientSelect/GenericPatientSelectHorizontal.js